import { render, staticRenderFns } from "./JoinInfos.vue?vue&type=template&id=63f888e0&scoped=true"
import script from "./JoinInfos.vue?vue&type=script&lang=ts"
export * from "./JoinInfos.vue?vue&type=script&lang=ts"
import style0 from "./JoinInfos.vue?vue&type=style&index=0&id=63f888e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f888e0",
  null
  
)

export default component.exports